import { useEffect } from 'react';
import _ from 'underscore';

export const useErrorHandler = ({
  data, error, loading, notificationApi, errorCallback = _.noop, successCallback = _.noop,
}) => {
  useEffect(() => {
    if (loading) {
      return;
    }

    if (data) {
      successCallback({ data });
    } else {
      if (!_.isEmpty(_.get(error, 'Errors')) && _.isFunction(_.get(notificationApi, 'showWarning'))) {
        notificationApi.showWarning(error.Errors[0].Message);
      }

      errorCallback({ error }); // no matter error or falsy error
    }
  }, [data, error, loading, notificationApi, errorCallback, successCallback]);
};
